import React from 'react'
import styled, { css } from 'styled-components'
import Text, { useTranslations } from '../../utils/Text'
import Image from './Image'
import media from '../../utils/media'

const ContainerFull = styled.div`
  width: 102vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  margin-bottom: ${props => props.marginB}px;
  ${media.mobileL`
    margin-bottom: calc(${props => props.marginB}px/3);
  `}
`

const Container = styled.div`
  width: 102vw;
  max-width: 1440px;
  left: 50%;
  transform: translateX(-50%);
  position: relative;
  padding: 0 30px;
  margin-bottom: ${props => props.marginB}px;
  ${media.mobileL`
    padding: 0 0;
    margin-bottom: calc(${props => props.marginB}px/3);
  `}
  img {
    max-width: 100%;
  }
`

const ImageComponentFull = styled.div`
  background-image: url(${props => props.imgDesktop});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  height: 100vh;
  max-height: 600px;
  ${media.mobileL`
    background-image: url(${props => props.imgMobile});
    max-height: 300px;
  `}
`

const ImageComponentMargins = styled.div`
  display: block !important;
  width: 100%;
  height: ${props => props.maxHeight}px;
  background-image: url(${props => props.imgDesktop});
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: top center;
`

const HideMobile = styled.div`
  display: block;
  ${media.mobileL`
    display: none;
  `}
`

const HideDesktop = styled.div`
  display: none;
  ${media.mobileL`
    display: block;
    img {
      width: 100%;
    }
  `}
`

const TextContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  ${props =>
    props.mobileBox &&
    css`
      ${media.mobileL`
        position: relative;
        background-color: #fafafa;
        padding: 20px;
        top: 100%;
        transform: translate(-50%, 0%);
      `}
    `}
`

const TextComponent = styled.div`
  margin: 0 11.5%;
  max-width: 1200px;
  span {
    display: block !important;
    text-align: ${props => props.textPosition};
    p {
      font-size: 64px;
      line-height: 1.1;
      color: ${props => (props.color ? props.color : '#ffffff')};
      ${media.laptop`font-size: 45.5px;`}
      ${media.tablet`font-size: 34.4px;`}
      ${media.mobileL`font-size: 19px;`}
      @media only screen and (min-width: 1777px) {font-size: 80px;}
      @media only screen and (min-width: 1920px) {font-size: 118px;}
      em {
        font-style: normal;
        font-size: 72px;
        color: ${props => (props.color ? props.accent : props.color)};
        ${media.laptop`font-size: 50px;`}
        ${media.tablet`font-size: 38px;`}
        ${media.mobileL`font-size: 21px;`}
        @media only screen and (min-width: 1777px) {font-size: 89px;}
        @media only screen and (min-width: 1920px) {font-size: 128px;}
      }
      strong {
        font-weight: 800 !important;
      }
    }
  }
  ${media.mobileL`
    p {
      color: ${props => (props.mobileBox ? '#414141' : props.color)};
    }
    span {
      text-align: ${props =>
        props.textPosition && !props.mobileBox
          ? props.textPosition
          : 'center'};
    }
  `}
`

export default function BannerFullWidth({ config }) {
  const {
    imgDesktop,
    imgMobile,
    title1,
    title2,
    type,
    alt,
    maxHeight,
    marginB,
    full,
    color,
    accent,
    textPosition,
    mobileBox,
    optional,
  } = config

  const imgDesktopToShow = useTranslations(imgDesktop, { optional })
  const imgMobileToShow = useTranslations(imgMobile, { optional })
  if (
    optional &&
    imgDesktopToShow === null &&
    imgMobileToShow === null
  )
    return null

  return (
    <>
      {full ? (
        <ContainerFull
          className="container-wrapper"
          marginB={marginB}
        >
          {type === 'cover' && (
            <ImageComponentFull
              imgDesktop={imgDesktopToShow}
              imgMobile={imgMobileToShow}
              maxHeight={maxHeight}
            />
          )}
          {type === 'resize' && (
            <>
              <HideMobile maxHeight={maxHeight}>
                <Image
                  src={imgDesktopToShow}
                  alt={alt}
                  classNameImage="img-fluid w-100"
                />
              </HideMobile>
              <HideDesktop maxHeight={maxHeight}>
                <Image
                  src={imgMobileToShow}
                  alt={alt}
                  classNameImage="img-fluid w-100"
                />
              </HideDesktop>
            </>
          )}
          {type === 'margins' && (
            <>
              <HideMobile maxHeight={maxHeight}>
                <ImageComponentMargins
                  imgDesktop={imgDesktopToShow}
                  maxHeight={maxHeight}
                />
              </HideMobile>
              <HideDesktop maxHeight={maxHeight}>
                <Image
                  src={imgMobileToShow}
                  alt={alt}
                  classNameImage="img-fluid w-100"
                />
              </HideDesktop>
            </>
          )}
          {title1 && (
            <TextContainer mobileBox={mobileBox}>
              <TextComponent
                color={color}
                accent={accent}
                textPosition={textPosition}
                mobileBox={mobileBox}
              >
                <Text id={title1} markdown />
                {title2 && <Text id={title2} markdown />}
              </TextComponent>
            </TextContainer>
          )}
        </ContainerFull>
      ) : (
        <Container marginB={marginB}>
          <HideMobile maxHeight={maxHeight}>
            <img src={imgDesktopToShow} alt={alt} />
          </HideMobile>
          <HideDesktop maxHeight={maxHeight}>
            <img src={imgMobileToShow} alt={alt} />
          </HideDesktop>
        </Container>
      )}
    </>
  )
}
